export default __webpack_public_path__ + "static/macbook-e0a75912846fef7dc36faf878923a3eb.svg";